// src/pages/Register.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../styles/Register.css";

const Register = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [depotName, setDepotName] = useState("");
    const [address, setAddress] = useState("");
    // Tank states
    const [tankName, setTankName] = useState("");
    const [tankCapacity, setTankCapacity] = useState("");
    const [tankHeight, setTankHeight] = useState("");

    // State untuk SENSOR UTAMA (Wajib)
    const [sensorIdMain, setSensorIdMain] = useState("");
    const [sensorNameMain, setSensorNameMain] = useState("");

    // State untuk SENSOR OPSIONAL (Array of objects)
    const [optionalSensors, setOptionalSensors] = useState([
        { id: '', name: '' }, { id: '', name: '' }, { id: '', name: '' },
        { id: '', name: '' }, { id: '', name: '' }, { id: '', name: '' } // 6 optional sensors
    ]);

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleOptionalSensorChange = (index, field, value) => {
        const newOptionalSensors = [...optionalSensors];
        newOptionalSensors[index][field] = value;
        setOptionalSensors(newOptionalSensors);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");

        // ✅ VALIDASI AWAL KOLOM WAJIB
        if (!username || !password || !depotName || !address || !sensorIdMain || !sensorNameMain || !tankName || !tankCapacity || !tankHeight) {
            setError("Semua kolom wajib (Username, Password, Nama Depot, Alamat, ID Sensor Utama, Nama Sensor Utama, Nama Tangki, Kapasitas Tangki, Tinggi Tangki) harus diisi!");
            return;
        }

        // Kumpulkan data tangki (hanya satu tangki dari form ini)
        const tankData = {
            tank_name: tankName,
            capacity: parseFloat(tankCapacity),
            height_cm: parseFloat(tankHeight)
        };
        // Validasi minimal tangki
        if (!tankData.tank_name || isNaN(tankData.capacity) || tankData.capacity <= 0 || isNaN(tankData.height_cm) || tankData.height_cm <= 0) {
            setError("Nama Tangki, Kapasitas Tangki, dan Tinggi Tangki harus diisi dengan nilai yang valid.");
            return;
        }

        // Kumpulkan data sensor (utama + opsional)
        // Perhatikan bahwa backend Anda (authRoutes.js) mengharapkan `sensor_id_main`, `sensor_name_main`, dan `optional_sensors`
        // Bukan `sensors` sebagai array objek dengan `sensorId`, `namaSensor`, `isRegistered`.
        // Kita perlu menyesuaikan payload yang dikirim dari frontend agar sesuai dengan apa yang diharapkan backend.
        // Berdasarkan authRoutes.js: `sensor_id_main`, `sensor_name_main`, `optional_sensors` (array objek {id, name})

        const dataToSend = {
            username,
            password,
            depot_name: depotName,
            address,
            tank_name: tankData.tank_name,
            capacity: tankData.capacity,
            height_cm: tankData.height_cm,
            sensor_id_main: sensorIdMain,      // Kirim sebagai properti terpisah
            sensor_name_main: sensorNameMain,  // Kirim sebagai properti terpisah
            optional_sensors: optionalSensors.filter(s => s.id || s.name) // Filter yang kosong
                                              .map(s => ({ id: s.id, name: s.name })) // Pastikan format {id, name}
        };

        try {
            const response = await axios.post("https://depotaircerdas.com/api/auth/register", dataToSend); // ✅ Kirim dataToSend

            if (response.status === 202) {
                setMessage(response.data.message);
                // navigate("/registration-submitted");
                // Opsional: reset form setelah sukses
                setUsername('');
                setPassword('');
                setDepotName('');
                setAddress('');
                setTankName('');
                setTankCapacity('');
                setTankHeight('');
                setSensorIdMain('');
                setSensorNameMain('');
                setOptionalSensors([
                    { id: '', name: '' }, { id: '', name: '' }, { id: '', name: '' },
                    { id: '', name: '' }, { id: '', name: '' }, { id: '', name: '' }
                ]);
            }
        } catch (err) {
            console.error("Registration request error:", err.response ? err.response.data : err.message);
            setError(err.response?.data?.message || "Gagal mengirim permintaan registrasi.");
        }
    };

    return (
        <div className="register-container">
            <div className="register-box">
                <button onClick={() => navigate(-1)} className="btn-back">⬅ Kembali</button>
                <h2>Kirim Permintaan Registrasi Depot Air</h2>
                {error && <p className="error-message">{error}</p>}
                {message && <p className="success-message">{message}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-two-columns">
                        {/* Kolom Kiri: Info Dasar & Sensor Wajib */}
                        <div className="column-left">
                            <div className="input-group">
                                <input type="text" placeholder="Username" name="username" value={username} onChange={(e) => setUsername(e.target.value)} required />
                            </div>
                            <div className="input-group">
                                <input type="password" placeholder="Password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                            </div>
                            <div className="input-group">
                                <input type="text" placeholder="Nama Depot" name="depot_name" value={depotName} onChange={(e) => setDepotName(e.target.value)} required />
                            </div>
                            <div className="input-group">
                                <input type="text" placeholder="Alamat" name="address" value={address} onChange={(e) => setAddress(e.target.value)} required />
                            </div>
                            
                            <h3>Informasi Sensor Utama (Wajib)</h3>
                            <div className="sensor-pair-group">
                                <div className="input-group">
                                    {/* ✅ Tambahkan name="sensor_id_main" */}
                                    <input type="text" placeholder="ID Sensor Utama" name="sensor_id_main" value={sensorIdMain} onChange={(e) => setSensorIdMain(e.target.value)} required />
                                </div>
                                <div className="input-group">
                                    {/* ✅ Tambahkan name="sensor_name_main" */}
                                    <input type="text" placeholder="Nama Sensor Utama" name="sensor_name_main" value={sensorNameMain} onChange={(e) => setSensorNameMain(e.target.value)} required />
                                </div>
                            </div>

                            <h3>Informasi Tangki (Wajib)</h3>
                            <div className="tank-pair-group">
                                <div className="input-group">
                                    {/* ✅ Tambahkan name="tank_name" */}
                                    <input type="text" placeholder="Nama Tangki" name="tank_name" value={tankName} onChange={(e) => setTankName(e.target.value)} required />
                                </div>
                                <div className="input-group">
                                    {/* ✅ Tambahkan name="tank_capacity" */}
                                    <input type="number" placeholder="Kapasitas Tangki (Liter)" name="tank_capacity" value={tankCapacity} onChange={(e) => setTankCapacity(e.target.value)} required />
                                </div>
                            </div>
                            <div className="input-group">
                                {/* ✅ Tambahkan name="tank_height" */}
                                <input type="number" placeholder="Tinggi Tangki (cm)" name="tank_height" value={tankHeight} onChange={(e) => setTankHeight(e.target.value)} required />
                            </div>
                        </div>

                        {/* Kolom Kanan: Sensor Opsional */}
                        <div className="column-right">
                            <h3>Informasi Sensor Lain (Opsional)</h3>
                            {optionalSensors.map((sensor, index) => (
                                <div key={index} className="sensor-pair-group">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            placeholder={`ID Sensor ${index + 2}`}
                                            value={sensor.id}
                                            onChange={(e) => handleOptionalSensorChange(index, 'id', e.target.value)}
                                        />
                                    </div>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            placeholder={`Nama Sensor ${index + 2}`}
                                            value={sensor.name}
                                            onChange={(e) => handleOptionalSensorChange(index, 'name', e.target.value)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <button type="submit" className="btn-register">Kirim Permintaan</button>
                </form>
                <p>Sudah punya akun? <a href="/login">Masuk</a></p>
            </div>
        </div>
    );
};

export default Register;